export const selectEstates = (state) => state.estates.estates;
export const selectEstateById = (state, id) =>
  selectEstates(state).find((estate) => estate.id === id);
